(function () {
  var grid = document.getElementById('mm-wishlist-grid');
  var emptyState = document.getElementById('mm-wishlist-empty');
  if (!grid || !emptyState) return;

  function renderEmptyStateIfNeeded() {
    var hasCards = grid.querySelector('.mm-wishlist-card') !== null;
    grid.hidden = !hasCards;
    emptyState.hidden = hasCards;
  }
  window.mmRenderWishlistEmptyStateIfNeeded = renderEmptyStateIfNeeded;

  function updateCartBubble(itemCount) {
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
      el.textContent = itemCount > 0 ? String(itemCount) : '';
      el.classList.toggle('hidden', itemCount === 0);
    });
    document.querySelectorAll('.cart-bubble').forEach(function (el) {
      el.classList.toggle('visually-hidden', itemCount === 0);
    });
  }

  function addToCart(variantId, button, redirectToCheckout) {
    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = redirectToCheckout ? 'Yönlendiriliyor...' : 'Ekleniyor...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw err;
          });
        }
        return response.json();
      })
      .then(function () {
        if (redirectToCheckout) {
          window.location.href = '/checkout';
          return;
        }
        return fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            updateCartBubble(cart.item_count);
            button.textContent = 'Eklendi ✓';
            setTimeout(function () {
              button.textContent = originalText;
              button.disabled = false;
            }, 1500);
          });
      })
      .catch(function () {
        button.textContent = 'Tekrar deneyin';
        setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      });
  }

  function buildActions(variant) {
    var actions = document.createElement('div');
    actions.className = 'mm-wishlist-card__actions';

    if (!variant) {
      var soldOut = document.createElement('button');
      soldOut.type = 'button';
      soldOut.className = 'mm-wishlist-action-btn mm-wishlist-action-btn--disabled';
      soldOut.textContent = 'Stokta Yok';
      soldOut.disabled = true;
      actions.appendChild(soldOut);
      return actions;
    }

    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'mm-wishlist-action-btn mm-wishlist-action-btn--add';
    addBtn.textContent = 'Sepete Ekle';
    addBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      addToCart(variant.id, addBtn, false);
    });

    var buyBtn = document.createElement('button');
    buyBtn.type = 'button';
    buyBtn.className = 'mm-wishlist-action-btn mm-wishlist-action-btn--buy';
    buyBtn.textContent = 'Satın Al';
    buyBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      addToCart(variant.id, buyBtn, true);
    });

    actions.appendChild(addBtn);
    actions.appendChild(buyBtn);
    return actions;
  }

  function buildCard(product) {
    var image = product.featured_image || (product.images && product.images[0]);
    var price = (product.price / 100).toLocaleString('tr-TR', { style: 'currency', currency: Shopify.currency ? Shopify.currency.active : 'TRY' });
    var variant = (product.variants || []).filter(function (v) {
      return v.available;
    })[0];

    var card = document.createElement('a');
    card.className = 'mm-wishlist-card';
    card.href = product.url;
    card.setAttribute('data-wishlist-handle', product.handle);

    var media = document.createElement('div');
    media.className = 'mm-wishlist-card__media';
    if (image) {
      var img = document.createElement('img');
      img.src = image;
      img.alt = product.title;
      img.loading = 'lazy';
      media.appendChild(img);
    }

    var wishlistButton = document.createElement('button');
    wishlistButton.type = 'button';
    wishlistButton.className = 'mm-wishlist-btn is-active';
    wishlistButton.setAttribute('data-product-handle', product.handle);
    wishlistButton.setAttribute('aria-pressed', 'true');
    wishlistButton.setAttribute('aria-label', 'Favorilerden çıkar');
    wishlistButton.innerHTML = '<svg class="mm-wishlist-btn__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-10-9.3C.5 8 1.8 4.5 5 3.4c2.2-.8 4.5.1 6 2 1.5-1.9 3.8-2.8 6-2 3.2 1.1 4.5 4.6 3 7.8-2.5 4.7-10 9.3-10 9.3z"/></svg>';
    media.appendChild(wishlistButton);

    var title = document.createElement('p');
    title.className = 'mm-wishlist-card__title';
    title.textContent = product.title;

    var priceEl = document.createElement('span');
    priceEl.className = 'mm-wishlist-card__price';
    priceEl.textContent = price;

    card.appendChild(media);
    card.appendChild(title);
    card.appendChild(priceEl);
    card.appendChild(buildActions(variant));

    return card;
  }

  function loadWishlistProducts() {
    var handles = window.mmWishlist ? window.mmWishlist.get() : [];

    if (handles.length === 0) {
      renderEmptyStateIfNeeded();
      return;
    }

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (response) {
            return response.ok ? response.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      grid.innerHTML = '';
      products.forEach(function (product) {
        if (product) grid.appendChild(buildCard(product));
      });
      renderEmptyStateIfNeeded();
    });
  }

  document.addEventListener('DOMContentLoaded', loadWishlistProducts);
})();
